"use client";

import { useState, useEffect } from "react";
import { InferenceType } from "@/lib/playground-utils";
import PlaygroundForm from "./playground-form";
import PlaygroundInferences from "./playground-inferences";

export default function Playground({
  inferenceUrl,
  variant,
  sampleImages = []
}: {
  inferenceUrl: string;
  variant?: string;
  sampleImages?: string[];
}) {
  const [inferences, setInferences] = useState<InferenceType[]>([]);

  // Warm connection on mount and poll every 30s to avoid slow first request
  useEffect(() => {
    const warm = () => fetch(`${inferenceUrl}/models`).catch(() => {});
    warm();
    const interval = setInterval(warm, 30000);
    return () => clearInterval(interval);
  }, [inferenceUrl]);

  return (
    <>
      <PlaygroundForm
        inferenceUrl={inferenceUrl}
        variant={variant}
        sampleImages={sampleImages}
        setInferences={setInferences}
      />
      <PlaygroundInferences inferences={inferences} />
    </>
  );
}
